import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import * as FileSaver from 'file-saver';
import * as React from 'react';
import XLSX from 'sheetjs-style';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import moment from 'moment';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  Tooltip,
  IconButton,
  TableContainer,
  TablePagination,
  Box,
  Grid,
} from '@mui/material';

import Link from '@mui/material/Link';
import TextField from '@mui/material/TextField';
import PhoneInput from 'react-phone-input-2';

import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import dayjs from 'dayjs';

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import CircularProgress from '@mui/material/CircularProgress';

import {
  collection,
  getDocs,
  getFirestore,
  addDoc,
  updateDoc,
  doc,
  serverTimestamp,
  onSnapshot,
  query,
  orderBy,
  limitToLast,
  Timestamp,
  writeBatch,
} from 'firebase/firestore';
import { getDatabase, ref as dbref, runTransaction, set, child, get, update, remove } from 'firebase/database';
import { initializeApp } from 'firebase/app';
import { getStorage, ref, uploadBytesResumable, getDownloadURL, deleteObject } from 'firebase/storage';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

import DeleteOutline from '@mui/icons-material/DeleteOutline';

import LinearProgress from '@mui/material/LinearProgress';

// components
import Label from '../../components/label';
import Iconify from '../../components/iconify';
import Scrollbar from '../../components/scrollbar';
// sections
import { UserListHead, UserListToolbar } from '../../sections/@dashboard/microsite';

import { UserAuth } from '../../context/AuthContext';

const firebaseConfig = {
  apiKey: 'AIzaSyDLVrlBPuai36n-i4F5HQVTjSMkVeGVBak',
  authDomain: 'onetweb-e3d8e.firebaseapp.com',
  databaseURL: 'https://onetweb-e3d8e-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'onetweb-e3d8e',
  storageBucket: 'onetweb-e3d8e.firebasestorage.app',
  messagingSenderId: '60910494595',
  appId: '1:60910494595:web:2dc6bf320d67371af04cb6',
  measurementId: 'G-0ZTHXZBNP9',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Cloud Firestore and get a reference to the service
const db = getFirestore(app);

const rtdb = getDatabase(app);

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'id', label: 'ID', alignRight: false },
  { id: 'registered', label: 'Registered User', alignRight: false },
  { id: 'created', label: 'Created', alignRight: false },
  { id: 'prefix', label: 'Prefix', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: 'title', label: 'Title', alignRight: false },
  { id: 'subtitle', label: 'Sub Title', alignRight: false },
  { id: 'description', label: 'Description', alignRight: false },
  { id: 'bgimage', label: 'BG Image', alignRight: false },
  { id: 'thumbnail', label: 'Thumbnail', alignRight: false },
  { id: '' },
];

// ----------------------------------------------------------------------

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label="first page">
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

function descendingComparator(a, b, orderBy2) {
  if (b[orderBy2] < a[orderBy2]) {
    return -1;
  }
  if (b[orderBy2] > a[orderBy2]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy2) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy2)
    : (a, b) => -descendingComparator(a, b, orderBy2);
}

function applySortFilter(array, comparator, query, select) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    if (select === 'title') {
      return filter(array, (_user) => _user.title.toLowerCase().indexOf(query.toLowerCase()) !== -1);
    }

    if (select === 'id') {
      return filter(array, (_user) => _user.id.toLowerCase().indexOf(query.toLowerCase()) !== -1);
    }

    if (select === 'prefix') {
      return filter(array, (_user) => _user.prefix.toLowerCase().indexOf(query.toLowerCase()) !== -1);
    }
  }
  return stabilizedThis.map((el) => el[0]);
}

const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const fileExtension = '.xlsx';

export default function ProductPage() {
  const { user } = UserAuth();

  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('desc');

  const [selected, setSelected] = useState([]);

  const [orderBy2, setOrderBy2] = useState('created');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [row, setRow] = useState([]);

  const [fileUrl, setFileUrl] = useState(null);

  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const [uploadDialogOpen, setUploadDialogOpen] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadedPhotos, setUploadedPhotos] = useState([]); // ← existing + newly uploaded

  const [statusdevice, setStatus] = useState('');
  const [emailaddress, setEmail] = useState('');
  const [cityname, setCity] = useState('');
  const [activationDate, setActivationDate] = useState('');
  const [name, setName] = useState('');
  const [mobileNum, setMobileNum] = React.useState('');
  const [userRole, setUserRole] = useState('super_admin');

  const [title, setTitle] = useState('');
  const [subtitle, setsubTitle] = useState('');
  const [venue, setVenue] = useState('');
  const [desc, setDesc] = useState('');
  const [startdate, setstartDate] = useState('');
  const [enddate, setendDate] = useState('');
  const [starttime, setstartTime] = useState('');
  const [endtime, setendTime] = useState('');

  const handleChangeStatus = (event) => {
    setStatus(event.target.value);
  };

  const [select, setSelect] = useState('id');

  const handleChangeSelect = (event) => {
    setSelect(event.target.value);
  };

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogOpen2, setDialogOpen2] = useState(false);
  const [dialogOpen3, setDialogOpen3] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [openDetails, setOpenDetails] = useState(false);
  const [dialogLoading, setDialogLoading] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  const handleCloseDetails = () => {
    setOpenDetails(false);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleDialogClose2 = () => {
    setDialogOpen2(false);
  };

  const handleDialogClose3 = () => {
    setDialogOpen3(false);
  };

  const handleDialogSubmit = () => {
    update(dbref(rtdb, `event/${selectedItem.id}`), {
      title: title || null,
      subtitle: subtitle || null,
      venue: venue || null,
      status: statusdevice || null,
      description: desc || null,
      start_date: startdate.format() || null,
      end_date: enddate.format() || null,
      start_time: starttime.format() || null,
      end_time: endtime.format() || null,
    });

    setDialogOpen(false);
  };

  const handleOnDelete = () => {
    setOpenDelete(true);
    setOpen(false);
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleSubmitDelete = async () => {
    const currentIndex = row.map((val) => val.id).indexOf(selectedItem.id);

    if (currentIndex > -1) {
      row.splice(currentIndex, 1);
    }

    remove(child(dbref(rtdb), `event/${selectedItem.id}`)).then(() => {
      setOpenDelete(false);
    });
  };

  useEffect(() => {
    if (uploadDialogOpen && selectedItem) {
      const photosRef = dbref(rtdb, `event/${selectedItem.id}/photos`);
      get(photosRef).then((snapshot) => {
        if (snapshot.exists()) {
          const data = Object.values(snapshot.val());
          setUploadedPhotos(data);
        } else {
          setUploadedPhotos([]);
        }
      });
    }
  }, [uploadDialogOpen, selectedItem]);

  useEffect(() => {
    let _user = '';
    if (user && user.reloadUserInfo && user.reloadUserInfo.customAttributes) {
      _user = JSON.parse(user.reloadUserInfo.customAttributes);
    }
    setUserRole(_user.role);

    const arr = [];
    get(child(dbref(rtdb), `event`))
      .then((snapshot) => {
        if (snapshot.exists()) {
          snapshot.forEach((doc) => {
            arr.push({
              ...doc.val(),
              id: doc.key,
            });
          });

          setRow(arr);
          setLoading(false);
        } else {
          setRow([]);
          setLoading(false);
          console.log('No data available');
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const getUnique = (arr, index) => {
    const unique = arr
      .map((e) => e[index])

      // store the keys of the unique objects
      .map((e, i, final) => final.indexOf(e) === i && i)

      // eliminate the dead keys & store unique objects
      .filter((e) => arr[e])
      .map((e) => arr[e]);

    return unique;
  };

  const handleChangeMobileNum = (event) => {
    setMobileNum(event.trim());
  };

  const handleChangeEmail = (event) => {
    setEmail(event.target.value.trim());
  };

  const handleChangeTitle = (event) => {
    setTitle(event.target.value.trim());
  };

  const handleChangeActivationDate = (event) => {
    setActivationDate(event.target.value.trim());
  };

  const handleChangeName = (event) => {
    setName(event.target.value.trim());
  };

  const downloadExcel = async () => {
    setDialogOpen2(true);
  };

  const downloadExcelCreatedDate = async () => {
    setDialogOpen3(true);
  };

  const handleOnDetails = () => {
    setOpenDetails(true);
    setOpen(false);
  };

  const handleOnEdit = () => {
    setTitle(selectedItem.title);
    setsubTitle(selectedItem.subtitle);
    setVenue(selectedItem.venue);
    setDesc(selectedItem.description);
    setStatus(selectedItem.status ? selectedItem.status : 'in_progress');
    setstartDate(moment(selectedItem.start_date));
    setendDate(moment(selectedItem.end_date));
    setstartTime(moment(selectedItem.start_time));
    setendTime(moment(selectedItem.end_time));
    setDialogOpen(true);
    setOpen(false);
  };

  const handleOpenMenu = (event, row) => {
    setSelectedItem(row);
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy2 === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy2(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = row.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - row.length) : 0;

  const filteredUsers = applySortFilter(row, getComparator(order, orderBy2), filterName, select);

  const isNotFound = !filteredUsers.length && !!filterName;

  if (loading) {
    return (
      <Grid style={{ width: '100%', display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
        <Grid
          style={{
            width: '100%',
            marginTop: 60,
            maxWidth: 1200,
            display: 'flex',
            padding: 25,
            height: '80vh',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box sx={{ display: 'flex' }}>
            <CircularProgress color="inherit" />
          </Box>
        </Grid>
      </Grid>
    );
  }

  const renderStatus = (status) => {
    let _status = '';
    if (status === 'pending_verification') {
      _status = 'Pending Verification';
    } else if (status === 'verified') {
      _status = 'Verified';
    }

    return _status;
  };

  const renderFilePath = (path) => {
    const printUrl = async (_path) => {
      const storage = getStorage(app);
      const _url = await getDownloadURL(ref(storage, _path))
        .then((url) => url)
        .catch((error) => {
          // Handle any errors
        });
      setFileUrl(_url);
    };

    printUrl(path);

    return fileUrl;
  };

  return (
    <>
      <Helmet>
        <title> Event | OneT </title>
      </Helmet>

      <Dialog open={uploadDialogOpen} onClose={() => setUploadDialogOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>Upload Event Photos</DialogTitle>

        <DialogContent dividers>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Manage photos for <strong>{selectedItem?.title}</strong>
          </Typography>

          {/* --- File selector --- */}
          <Button variant="contained" component="label" sx={{ mb: 2 }}>
            Choose Photos
            <input
              hidden
              accept="image/*"
              multiple
              type="file"
              onChange={(e) => setSelectedFiles(Array.from(e.target.files))}
            />
          </Button>

          {selectedFiles.length > 0 && (
            <Typography variant="body2" color="text.secondary">
              {selectedFiles.length} file(s) selected
            </Typography>
          )}

          {uploading && (
            <Box sx={{ mt: 2 }}>
              <Typography variant="body2">Uploading... {uploadProgress}%</Typography>
              <LinearProgress variant="determinate" value={uploadProgress} />
            </Box>
          )}

          {/* --- Thumbnails --- */}
          {uploadedPhotos.length > 0 && (
            <Box
              sx={{
                mt: 2,
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(90px, 1fr))',
                gap: 1.5,
              }}
            >
              {uploadedPhotos.map((photo) => (
                <Box
                  key={photo.name}
                  sx={{
                    position: 'relative',
                    borderRadius: 1,
                    overflow: 'hidden',
                    boxShadow: '0 0 4px rgba(0,0,0,0.2)',
                  }}
                >
                  <img src={photo.url} alt={photo.name} style={{ width: '100%', height: 80, objectFit: 'cover' }} />
                  <IconButton
                    size="small"
                    sx={{
                      position: 'absolute',
                      top: 2,
                      right: 2,
                      backgroundColor: 'rgba(0,0,0,0.4)',
                      color: 'white',
                      '&:hover': { backgroundColor: 'rgba(255,0,0,0.6)' },
                    }}
                    onClick={async () => {
                      try {
                        const storage = getStorage(app);
                        await deleteObject(ref(storage, `event_photos/${selectedItem.id}/${photo.name}`));
                        await remove(dbref(rtdb, `event/${selectedItem.id}/photos/${photo.name.replace(/\W+/g, '_')}`));
                        setUploadedPhotos((prev) => prev.filter((p) => p.name !== photo.name));
                      } catch (err) {
                        console.error('Delete error:', err);
                        alert('❌ Failed to delete image.');
                      }
                    }}
                  >
                    <DeleteOutline sx={{ fontSize: 16 }} />
                  </IconButton>
                </Box>
              ))}
            </Box>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setUploadDialogOpen(false)}>Close</Button>
          <Button
            variant="contained"
            disabled={uploading || selectedFiles.length === 0}
            onClick={async () => {
              if (!selectedItem || selectedFiles.length === 0) return;
              try {
                setUploading(true);
                const storage = getStorage(app);
                const uploadedData = [];

                for (let i = 0; i < selectedFiles.length; i++) {
                  const file = selectedFiles[i];
                  const fileName = `${Date.now()}_${file.name}`;
                  const fileRef = ref(storage, `event_photos/${selectedItem.id}/${fileName}`);

                  await new Promise((resolve, reject) => {
                    const uploadTask = uploadBytesResumable(fileRef, file);
                    uploadTask.on(
                      'state_changed',
                      (snapshot) => {
                        const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                        setUploadProgress(progress);
                      },
                      reject,
                      async () => {
                        const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                        uploadedData.push({
                          name: fileName,
                          url: downloadURL,
                          uploadedAt: new Date().toISOString(),
                        });
                        resolve();
                      }
                    );
                  });
                }

                // ✅ write to DB
                const eventRef = dbref(rtdb, `event/${selectedItem.id}/photos`);
                const updates = {};
                uploadedData.forEach((photo) => {
                  const key = photo.name.replace(/\W+/g, '_');
                  updates[key] = photo;
                });
                await update(eventRef, updates);

                // merge with existing
                setUploadedPhotos((prev) => [...prev, ...uploadedData]);
                setSelectedFiles([]);
                setUploading(false);
                alert('✅ Photos uploaded successfully!');
              } catch (err) {
                console.error('Upload error:', err);
                alert('❌ Upload failed. Try again.');
                setUploading(false);
              }
            }}
          >
            {uploading ? 'Uploading...' : 'Upload'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={dialogOpen}
        onClose={handleDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Edit</DialogTitle>
        <DialogContent>
          <FormControl style={{ marginTop: 20 }} fullWidth>
            <InputLabel id="demo-simple-select-label">Status</InputLabel>
            <Select labelId="Status" id="Status" value={statusdevice} label="Status" onChange={handleChangeStatus}>
              <MenuItem value="completed">Completed</MenuItem>
              <MenuItem value="in_progress">In Progress</MenuItem>
            </Select>
          </FormControl>

          <Grid container spacing={2} style={{ marginTop: 10 }}>
            <Grid item xs={12} sm={12} md={12}>
              <TextField
                fullWidth
                required
                id="title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                label="Title"
                name="title"
                autoComplete="off"
              />
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <TextField
                fullWidth
                required
                value={subtitle}
                onChange={(e) => setsubTitle(e.target.value)}
                id="subtitle"
                label="Sub Title"
                name="subtitle"
                autoComplete="off"
              />
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <TextField
                fullWidth
                required
                onChange={(e) => setVenue(e.target.value)}
                value={venue}
                id="venue"
                label="Venue"
                name="venue"
                autoComplete="off"
              />
            </Grid>

            <Grid item xs={12} sm={12}>
              <TextField
                fullWidth
                required
                value={desc}
                onChange={(e) => setDesc(e.target.value)}
                id="description"
                label="Description"
                name="description"
                autoComplete="off"
                multiline
                rows={4}
              />
            </Grid>

            <Grid item xs={12} md={12}>
              <LocalizationProvider sx={{ width: '100%' }} dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Event Start Date"
                  value={startdate}
                  timezone="Asia/Singapore"
                  onChange={(newDate) => setstartDate(newDate)}
                  sx={{ width: '100%' }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12} md={12}>
              <LocalizationProvider sx={{ width: '100%' }} dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Event End Date"
                  value={enddate}
                  timezone="Asia/Singapore"
                  onChange={(newDate) => setendDate(newDate)}
                  sx={{ width: '100%' }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12} md={12}>
              <LocalizationProvider sx={{ width: '100%' }} dateAdapter={AdapterDayjs}>
                <TimePicker
                  label="Event Start Time"
                  value={starttime}
                  timezone="Asia/Singapore"
                  onChange={(newDate) => setstartTime(newDate)}
                  sx={{ width: '100%' }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12} md={12}>
              <LocalizationProvider sx={{ width: '100%' }} dateAdapter={AdapterDayjs}>
                <TimePicker
                  label="Event End Time"
                  value={endtime}
                  timezone="Asia/Singapore"
                  onChange={(newDate) => setendTime(newDate)}
                  sx={{ width: '100%' }}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose}>No</Button>
          <Button onClick={handleDialogSubmit} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openDelete}
        onClose={handleCloseDelete}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Delete event page</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this page?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDelete}>No</Button>
          <Button onClick={handleSubmitDelete} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Event
          </Typography>
          <Button variant="contained" href="/dashboard/new_event" startIcon={<Iconify icon="eva:plus-fill" />}>
            New Event
          </Button>
        </Stack>

        <Card>
          <UserListToolbar
            handleChangeSelect={handleChangeSelect}
            select={select}
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
          />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy2}
                  headLabel={TABLE_HEAD}
                  rowCount={row.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    const { id } = row;
                    const selectedUser = selected.indexOf(id) !== -1;

                    let _countryName = '';

                    if (row.country && row.country === 'srilanka') {
                      _countryName = 'Sri Lanka';
                    } else if (row.country && row.country === 'myanmar') {
                      _countryName = 'Myanmar';
                    } else if (row.country && row.country === 'brunei') {
                      _countryName = 'Brunei';
                    } else if (row.country && row.country === 'nepal') {
                      _countryName = 'Nepal';
                    } else {
                      _countryName = row.country;
                    }

                    let _status = '';

                    if (row.status && row.status === 'pending_verification') {
                      _status = 'Pending Verification';
                    } else if (row.status && row.status === 'verified') {
                      _status = 'Verified';
                    }

                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox" selected={selectedUser}>
                        <TableCell padding="checkbox">
                          <Checkbox checked={selectedUser} onChange={(event) => handleClick(event, id)} />
                        </TableCell>

                        <TableCell align="left">
                          <Link target="_blank" href={`/event/${row.prefix}`}>
                            {row.id}
                          </Link>
                        </TableCell>

                        <TableCell align="left">
                          <Link target="_blank" href={`/dashboard/event/${row.prefix}`}>
                            Registered Users
                          </Link>
                        </TableCell>

                        <TableCell align="left">
                          <Typography align="left" style={{ fontSize: 14 }}>
                            {`${new Date(row.created).getFullYear()}
                        -${new Date(row.created).getMonth() + 1}
                        -${new Date(row.created).getDate()}`}
                          </Typography>
                          <Typography align="left" style={{ fontSize: 14 }}>
                            {`${new Date(row.created).getHours()}: ${new Date(row.created).getMinutes()}`}
                          </Typography>
                        </TableCell>

                        <TableCell align="left">{row.prefix}</TableCell>

                        <TableCell align="left">
                          {row.status && row.status === 'completed' ? (
                            <Grid>
                              <Typography
                                sx={{
                                  fontSize: 14,
                                }}
                              >
                                Completed
                              </Typography>
                              <Button
                                style={{ width: 120 }}
                                variant="outlined"
                                onClick={() => {
                                  setSelectedItem(row);
                                  setUploadDialogOpen(true);
                                }}
                              >
                                Upload Photo
                              </Button>
                            </Grid>
                          ) : (
                            'In Progress'
                          )}
                        </TableCell>

                        <TableCell align="left">
                          <Tooltip title={row.title}>
                            <Typography
                              sx={{
                                fontSize: 14,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: '-webkit-box',
                                WebkitLineClamp: '2',
                                WebkitBoxOrient: 'vertical',
                              }}
                            >
                              {row.title}
                            </Typography>
                          </Tooltip>
                        </TableCell>

                        <TableCell align="left">
                          <Tooltip title={row.subtitle}>
                            <Typography
                              sx={{
                                fontSize: 14,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: '-webkit-box',
                                WebkitLineClamp: '2',
                                WebkitBoxOrient: 'vertical',
                              }}
                            >
                              {row.subtitle}
                            </Typography>
                          </Tooltip>
                        </TableCell>

                        <TableCell
                          style={{ overflow: 'hidden', textOverflow: 'ellipsis', width: '11rem' }}
                          align="left"
                        >
                          <Tooltip title={row.description}>
                            <Typography
                              sx={{
                                fontSize: 14,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: '-webkit-box',
                                WebkitLineClamp: '2',
                                WebkitBoxOrient: 'vertical',
                              }}
                            >
                              {row.description}
                            </Typography>
                          </Tooltip>
                        </TableCell>

                        <TableCell align="left">
                          <Link target="_blank" href={row.event_bg_fullPath}>
                            Link
                          </Link>
                        </TableCell>

                        <TableCell align="left">
                          <Link target="_blank" href={row.thumbnail_fullPath}>
                            Link
                          </Link>
                        </TableCell>

                        <TableCell align="right">
                          <IconButton size="large" color="inherit" onClick={(e) => handleOpenMenu(e, row)}>
                            <Iconify icon="eva:more-vertical-fill" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Not found
                          </Typography>

                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete words.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
            component="div"
            count={row.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            ActionsComponent={TablePaginationActions}
          />
        </Card>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 180,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem onClick={handleOnDelete} sx={{ color: 'error.main' }}>
          Delete
        </MenuItem>
        <MenuItem onClick={handleOnEdit}>Edit</MenuItem>
        <MenuItem
          onClick={() => {
            update(dbref(rtdb, `event/${selectedItem.id}`), {
              status: 'completed',
            });
            const currentIndex = row.map((val) => val.id).indexOf(selectedItem.id);

            if (currentIndex !== -1) {
              row[currentIndex].status = 'completed';
              setRow([...row]); // spread to trigger re-render (important!)
            }
            setOpen(false);
          }}
          sx={{ color: 'primary.main' }}
        >
          Mark as Completed
        </MenuItem>
        <MenuItem
          onClick={() => {
            update(dbref(rtdb, `event/${selectedItem.id}`), {
              status: 'in_progress',
            });
            const currentIndex = row.map((val) => val.id).indexOf(selectedItem.id);

            if (currentIndex !== -1) {
              row[currentIndex].status = 'in_progress';
              setRow([...row]); // spread to trigger re-render (important!)
            }
            setOpen(false);
          }}
          sx={{ color: 'primary.main' }}
        >
          Mark as In Progress
        </MenuItem>
      </Popover>
    </>
  );
}
